<template>
    <div class="col-md-3 mb-sm-3 mb-md-0">
        <!-- <b-button
			variant="success"
			block
			size="lg"
			squared
			@click="redirectAcompanhamento"
		>
			<i class="mdi mdi-database-cog-outline mdi-18px"></i>
			Serviços/Intervenções
		</b-button> -->

        <b-list-group
            role="tablist"
            class="shadow bg-white h-100 p-b rounded-0"
        >
            <b-list-group-item
                @click="
                    page = 'acompanhamento';
                    $emit('page', page);
                "
                :class="page == 'acompanhamento' ? 'active' : ''"
                class="nav-link"
                href="#"
                role="tab"
            >
                Detalhes do Acompanhamento
            </b-list-group-item>
            <b-list-group-item
                @click="
                    page = 'avaliacao';
                    $emit('page', page);
                "
                :class="page == 'avaliacao' ? 'active' : ''"
                class="nav-link"
                href="#"
                role="tab"
            >
                Avaliações
            </b-list-group-item>
            <b-list-group-item
                @click="
                    page = 'atividade';
                    $emit('page', page);
                "
                :class="page == 'atividade' ? 'active' : ''"
                class="nav-link"
                href="#"
                role="tab"
            >
                Atividades / Evolução
            </b-list-group-item>
            <b-list-group-item
                @click="
                    page = 'atendimento';
                    $emit('page', page);
                "
                :class="page == 'atendimento' ? 'active' : ''"
                class="nav-link"
                href="#"
                role="tab"
            >
                Atendimentos / Cronograma
            </b-list-group-item>
            <b-list-group-item
                @click="
                    page = 'encaminhamento';
                    $emit('page', page);
                "
                :class="page == 'encaminhamento' ? 'active' : ''"
                class="nav-link"
                href="#"
                role="tab"
            >
                Encaminhamentos
            </b-list-group-item>
            <b-list-group-item
                @click="
                    page = 'oficio';
                    $emit('page', page);
                "
                :class="page == 'oficio' ? 'active' : ''"
                class="nav-link"
                href="#"
                role="tab"
            >
                Ofícios
            </b-list-group-item>
            <!-- <b-list-group-item
        @click="
          page = 'meta';
          $emit('page', page);
        "
        :class="page == 'meta' ? 'active' : ''"
        class="nav-link"
        href="#"
        role="tab"
      >
        Metas
      </b-list-group-item> -->
            <b-list-group-item
                @click="
                    page = 'comentario';
                    $emit('page', page);
                "
                :class="page == 'comentario' ? 'active' : ''"
                class="nav-link"
                href="#"
                role="tab"
            >
                Comentários
            </b-list-group-item>
            <b-list-group-item
                @click="
                    page = 'anexo';
                    $emit('page', page);
                "
                :class="page == 'anexo' ? 'active' : ''"
                class="nav-link"
                href="#"
                role="tab"
            >
                Anexos
            </b-list-group-item>
            <b-list-group-item
                @click="
                    page = 'estrategia';
                    $emit('page', page);
                "
                :class="page == 'estrategia' ? 'active' : ''"
                class="nav-link"
                href="#"
                role="tab"
            >
                Histórico de Intervenção
            </b-list-group-item>
            <b-list-group-item
                @click="
                    page = 'diagnostico';
                    $emit('page', page);
                "
                :class="page == 'diagnostico' ? 'active' : ''"
                class="nav-link"
                href="#"
                role="tab"
            >
                Histórico de Avaliações Técnicas Periódicas
            </b-list-group-item>
            <b-list-group-item
                @click="
                    page = 'historico_avaliacao';
                    $emit('page', page);
                "
                :class="page == 'historico_avaliacao' ? 'active' : ''"
                class="nav-link"
                href="#"
                role="tab"
            >
                Histórico de Avaliações
            </b-list-group-item>
            <!-- <b-list-group-item
        @click="
          page = 'desligamento';
          $emit('page', page);
        "
        :class="page == 'desligamento' ? 'active' : ''"
        class="nav-link"
        href="#"
        role="tab"
      >
        Desligamento
      </b-list-group-item> -->
        </b-list-group>
    </div>
</template>
<script>
export default {
    props: ["active"],
    data() {
        return { page: "acompanhamento" };
    },
    mounted() {
        if (this.active) {
            this.page = this.active;
        }
    },
    methods: {
        redirectAcompanhamento() {
            this.$router.push({
                path: `/dashboard/acompanhamentos/${this.$route.query.familia_id}`,
                query: { familia_id: this.$route.query.familia_id },
            });
        },
    },
};
</script>
